import React from 'react';
import {action, observable} from "mobx";
import {observer} from "mobx-react";

/**
 * Component to show gift received
 */

@observer
export class GiftDisplay extends React.Component<any, any> {

    // should box be opened
    @observable openBoxNow:boolean = false;

    public constructor(props:any) {
        super(props);

        // when component loads, start the box openning timer
        this.startOpenBoxTimer();
    }

    public render(): any {
        return (
            <div >
                <h1>Congratulations</h1>

                <div style={{display:'flex'}}>
                    <div style={{flexGrow:100}} >

                        <p>Hooray!! You did it {String.fromCodePoint(0x1F389)}! You are so smart. {String.fromCodePoint(0x1F913)}</p>

                        <p>Your gift is a new <span style={{fontWeight:'bold'}}>Monorepo</span> {String.fromCodePoint(0x1F602)}. Congratulations on behalf of the VGift Team!</p>
                    </div>
                    <div>
                        <div style={{paddingLeft: 120, width: '320px'}}>
                            <div className="box" >
                                <div className={this.openBoxNow ? "box-body box-body-open": "box-body"} >
                                    <img className="img" src="https://miro.medium.com/max/700/1*ITPWdo1leQjJ4mogqBvrlQ.png" width={320} height={180}/>
                                    <div className="box-lid" >
                                        <div className="box-bowtie" > </div >

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }

    /**
     * Starts openning the box immediately when called.
     */
    @action.bound
    private setOpenBoxNow() {
        this.openBoxNow = true;
    }

    /**
     * Start timer which will open box with 2 second delay.
     */
    private startOpenBoxTimer() {
        setTimeout(()=>{this.setOpenBoxNow()}, 2000)
    }

}
